import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white" }, "Invoice", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "card-body p-0" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"card-rounded bg-body mt-n10 position-relative card-px py-15\"><div class=\"row g-0 mb-7\"><div class=\"col mx-5\"><div class=\"fs-6 text-gray-400\">Total</div><div class=\"fs-2 fw-bolder text-gray-800\">650</div></div><div class=\"col mx-5\"><div class=\"fs-6 text-gray-400\">Comissions</div><div class=\"fs-2 fw-bolder text-gray-800\">29,500</div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([`bg-${_ctx.widgetColor}`, "card-header border-0 py-5"])
    }, _hoisted_2, 2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_apexchart, {
        class: _normalizeClass([`bg-${_ctx.widgetColor}`, "mixed-widget-12-chart card-rounded-bottom"]),
        options: _ctx.chartOptions,
        series: _ctx.series,
        height: "200",
        type: "bar"
      }, null, 8, ["class", "options", "series"]),
      _hoisted_4
    ])
  ], 2))
}